import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const createLead = (payload) => api.post("/leads", payload).then((r) => r.data);
export const estimateCost = (payload) => api.post("/estimate", payload).then((r) => r.data);
export const subscribeNewsletter = (email) => api.post("/newsletter", { email }).then((r) => r.data);

export const adminLogin = (password) => api.post("/admin/login", { password }).then((r) => r.data);
export const fetchLeads = (token) => api.get("/leads", { headers: { "x-admin-token": token } }).then((r) => r.data);
export const updateLeadStatus = (id, status, token) =>
  api.patch(`/leads/${id}`, { status }, { headers: { "x-admin-token": token } }).then((r) => r.data);
export const deleteLead = (id, token) =>
  api.delete(`/leads/${id}`, { headers: { "x-admin-token": token } }).then((r) => r.data);
